module.exports = __webpack_public_path__ + "static/bkg-footer-4464368508d55d51c613169b1b11077e.jpg";